// Flat, modern color scheme matching mobile app
export const colors = {
    // Core brand colors
    PRIMARY: '#2563EB',               // Primary Blue
    ACCENT: 'rgba(15,238,188,0.18)',  // Accent Cyan (lighter)
    ACCENT_SOLID: '#0FEEBC',          // Accent Cyan (solid)
    DARK: '#111827',                  // Dark background/text
    WHITE: '#FFFFFF',                 // White

    // Landing page
    LandingPage_Background: '#F9FAFB',
    LandingPage_Description: '#111827',

    // Buttons
    Button_Primary: '#2563EB',
    Button_Secondary: '#0FEEBC',

    // Header
    Header_Background: '#FFFFFF',
    Header_Content: '#111827',
    Header: '#2563EB',
    Header_Text: '#FFFFFF',
    Header_Text_back: '#2563EB',
    HEADER: '#2563EB',

    // Table
    Table_Header: '#2563EB',

    // Actions
    Action_Button_Back: '#2563EB',
    ALERT_BUTTON_GOTO_COLOR: '#2563EB',
    ALERT_BUTTON_CLOSE_COLOR: '#111827',

    // Borders & backgrounds
    BORDER_BACKGROUND: '#E5E7EB',
    CAR_BOX_EVEN: '#FFFFFF',
    CAR_BOX_ODD: 'rgba(15,238,188,0.12)',

    // Base colors
    Black: '#111827',
    White: '#FFFFFF',

    // Text colors (matching mobile app)
    TEXT_PRIMARY: '#111827',
    TEXT_SECONDARY: '#6B7280',
    TEXT_MUTED: '#9CA3AF',
    TEXT_LIGHT: '#FFFFFF',

    // Status colors
    SUCCESS: '#10B981',
    WARNING: '#F59E0B',
    DANGER: '#EF4444',
    INFO: '#2563EB',

    // Background variants
    BACKGROUND: '#F9FAFB',
    BACKGROUND_PAPER: '#FFFFFF',
    BACKGROUND_DARK: '#111827',
    BACKGROUND_HOVER: '#F3F4F6',

    // Card styles
    CARD_BACKGROUND: '#FFFFFF',
    CARD_BORDER: '#E5E7EB',
    CARD_SHADOW: '0 1px 3px rgba(0,0,0,0.08)',

    // Legacy aliases used across dashboards (mapped to brand palette)
    Primary_Blue: '#2563EB',
    Dark_Blue: '#1D4ED8',
    Primary_Green: '#0FEEBC',
    Dark_Green: '#0CA88F',
    Accent_Green: '#A7F3D0',
    Primary_Cyan: '#06B6D4',
    SECONDARY: '#0FEEBC',
    Background_Light: '#F9FAFB',
    Table_Row_Hover: '#F3F4F6',
    Button_Action: '#F59E0B',
    Button_Delete: '#EF4444'
};

// Common component styles matching mobile app
export const componentStyles = {
    // Card styles
    card: {
        backgroundColor: colors.WHITE,
        borderRadius: 16,
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        border: `1px solid ${colors.BORDER_BACKGROUND}`,
        padding: 24,
    },
    cardElevated: {
        backgroundColor: colors.WHITE,
        borderRadius: 16,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        padding: 24,
    },
    // Button styles
    buttonPrimary: {
        backgroundColor: colors.PRIMARY,
        color: colors.WHITE,
        borderRadius: 12,
        fontWeight: 600,
        textTransform: 'none',
        padding: '12px 24px',
        '&:hover': {
            backgroundColor: '#1D4ED8',
        },
    },
    buttonSecondary: {
        backgroundColor: colors.ACCENT_SOLID,
        color: colors.DARK,
        borderRadius: 12,
        fontWeight: 600,
        textTransform: 'none',
        padding: '12px 24px',
        '&:hover': {
            backgroundColor: '#0CA88F',
        },
    },
    buttonOutlined: {
        borderColor: colors.PRIMARY,
        color: colors.PRIMARY,
        borderRadius: 12,
        fontWeight: 600,
        textTransform: 'none',
        padding: '12px 24px',
        '&:hover': {
            backgroundColor: 'rgba(37,99,235,0.08)',
        },
    },
    // Input styles
    input: {
        borderRadius: 12,
        backgroundColor: colors.WHITE,
        '& .MuiOutlinedInput-root': {
            borderRadius: 12,
            '& fieldset': {
                borderColor: colors.BORDER_BACKGROUND,
            },
            '&:hover fieldset': {
                borderColor: colors.PRIMARY,
            },
            '&.Mui-focused fieldset': {
                borderColor: colors.PRIMARY,
            },
        },
    },
    // Status badge styles
    statusBadge: {
        padding: '4px 12px',
        borderRadius: 20,
        fontSize: 12,
        fontWeight: 600,
        display: 'inline-flex',
        alignItems: 'center',
    },
    // Table styles
    tableHeader: {
        backgroundColor: colors.PRIMARY,
        color: colors.WHITE,
        fontWeight: 700,
    },
    tableRow: {
        '&:hover': {
            backgroundColor: colors.BACKGROUND_HOVER,
        },
    },
    // Modal styles
    modal: {
        backgroundColor: colors.WHITE,
        borderRadius: 16,
        boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
        padding: 24,
    },
};

// Status color mapping (matching mobile app)
export const statusColors = {
    NEW: { bg: '#FFF7ED', text: '#C2410C', label: 'New' },
    PAYMENT_PENDING: { bg: '#FEF3C7', text: '#92400E', label: 'Payment Pending' },
    ACCEPTED: { bg: '#DBEAFE', text: '#1E40AF', label: 'Accepted' },
    ARRIVED: { bg: '#E0E7FF', text: '#4338CA', label: 'Arrived' },
    STARTED: { bg: '#D1FAE5', text: '#047857', label: 'Started' },
    REACHED: { bg: '#CFFAFE', text: '#0E7490', label: 'Reached' },
    PENDING: { bg: '#FEF3C7', text: '#92400E', label: 'Pending' },
    PAID: { bg: '#D1FAE5', text: '#047857', label: 'Paid' },
    COMPLETE: { bg: '#D1FAE5', text: '#047857', label: 'Complete' },
    CANCELLED: { bg: '#FEE2E2', text: '#DC2626', label: 'Cancelled' },
};
